import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { 
  DashboardOutlined, 
  TeamOutlined, 
  UserOutlined, 
  BookOutlined, 
  CheckCircleOutlined,
  GlobalOutlined,
  DollarOutlined,
  HistoryOutlined,
  LogoutOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  SettingOutlined
} from '@ant-design/icons';
import { Layout, Menu, Avatar, Button, Dropdown, Space } from 'antd';
import './AdminiSidebarComponent.css';

const { Sider } = Layout;

function Sidebar({ setLoggedIn, profileImage, setProfileImage }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const [selectedKey, setSelectedKey] = useState(location.pathname);

  const menuItems = [
    {
      key: '/admin-page/dashboard',
      icon: <DashboardOutlined />,
      label: 'Dashboard',
      path: '/admin-page/dashboard'
    },
    {
      key: '/admin-page/teachers',
      icon: <TeamOutlined />,
      label: 'Teachers',
      path: '/admin-page/teachers'
    },
    {
      key: '/admin-page/students',
      icon: <UserOutlined />,
      label: 'Students',
      path: '/admin-page/students'
    },
    {
      key: '/admin-page/subjects',
      icon: <BookOutlined />,
      label: 'Subjects',
      path: '/admin-page/subjects'
    },
    {
      key: '/admin-page/classes',
      icon: <CheckCircleOutlined />,
      label: 'Class Approvals',
      path: '/admin-page/classes'
    },
    {
      key: '/admin-page/published',
      icon: <GlobalOutlined />,
      label: 'Published',
      path: '/admin-page/published'
    },
    {
      key: '/admin-page/payments',
      icon: <DollarOutlined />,
      label: 'Payments',
      path: '/admin-page/payments'
    },
    {
      key: '/admin-page/events',
      icon: <HistoryOutlined />,
      label: 'Events Logs',
      path: '/admin-page/events'
    }
  ];

  const handleMenuClick = ({ key }) => {
    setSelectedKey(key);
    navigate(key);
  };

  const userMenuItems = [
    {
      key: 'logout',
      label: 'Logout',
      icon: <LogoutOutlined />,
      danger: true
    }
  ];

  const handleUserMenuClick = ({ key }) => {
    switch(key) {
      case 'logout':
          localStorage.removeItem("accessToken");
          localStorage.removeItem("userInfo");
          localStorage.removeItem("userPhoto");
        navigate('/');
        break;
      default:
        break;
    }
  };

  return (
    <>
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={setCollapsed}
        width={260}
        className="admin-sidebar"
        theme="light"
        trigger={null}
      >
        {/* Sidebar Header */}
        <div className="sidebar-header">
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            className="sidebar-collapse-btn"
          />
        </div>

        {/* Navigation Menu */}
        <Menu
          mode="inline"
          selectedKeys={[selectedKey]}
          onClick={handleMenuClick}
          items={menuItems}
          className="sidebar-menu"
          inlineIndent={collapsed ? 0 : 24}
        />

        {/* User Menu */}
        {!collapsed && (
          <Dropdown menu={{ items: userMenuItems, onClick: handleUserMenuClick }} placement="topRight">
            <div className="user-menu">
              <Space direction="vertical" size={0} className="user-menu-info">
                <span className="user-menu-name">Administrator</span>
                <span className="user-menu-role">Super Admin</span>
              </Space>
            </div>
          </Dropdown>
        )}

        {collapsed && (
          <Dropdown menu={{ items: userMenuItems, onClick: handleUserMenuClick }} placement="topRight">
            <div className="user-menu-collapsed">
              <Avatar 
                size="large" 
                src="https://api.dicebear.com/7.x/avataaars/svg?seed=Admin" 
                className="user-menu-avatar-collapsed"
              />
            </div>
          </Dropdown>
        )}

        {/* Footer */}
        {!collapsed && (
          <div className="sidebar-footer">
            <p className="version">Version 2.0.1</p>
            <p className="copyright">© 2024 Beyondschools Academy</p>
          </div>
        )}
      </Sider>
    </>
  );
}

export default Sidebar;